// extracted by mini-css-extract-plugin
export default {"root":"ToggleSwitch_root__KAiaP","tooltip":"ToggleSwitch_tooltip__X4i40","slider":"ToggleSwitch_slider__4DF2K"};